var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 22C5.0875 22 4.73438 21.8531 4.44063 21.5594C4.14688 21.2656 4 20.9125 4 20.5V9.65C4 9.2375 4.14688 8.88438 4.44063 8.59063C4.73438 8.29688 5.0875 8.15 5.5 8.15H7.25V5.75C7.25 4.43583 7.71338 3.31563 8.64015 2.38938C9.56692 1.46313 10.6877 1 12.0027 1C13.3175 1 14.4375 1.46313 15.3625 2.38938C16.2875 3.31563 16.75 4.43583 16.75 5.75V8.15H18.5C18.9125 8.15 19.2656 8.29688 19.5594 8.59063C19.8531 8.88438 20 9.2375 20 9.65V20.5C20 20.9125 19.8531 21.2656 19.5594 21.5594C19.2656 21.8531 18.9125 22 18.5 22H5.5ZM5.5 20.5H18.5V9.65H5.5V20.5ZM12.0042 17C12.5347 17 12.9875 16.8164 13.3625 16.4492C13.7375 16.082 13.925 15.6406 13.925 15.125C13.925 14.625 13.7361 14.1708 13.3583 13.7625C12.9805 13.3542 12.5263 13.15 11.9958 13.15C11.4653 13.15 11.0125 13.3542 10.6375 13.7625C10.2625 14.1708 10.075 14.6292 10.075 15.1375C10.075 15.6458 10.2639 16.0833 10.6417 16.45C11.0195 16.8167 11.4737 17 12.0042 17ZM8.75 8.15H15.25V5.75C15.25 4.84722 14.9343 4.07986 14.3029 3.44792C13.6716 2.81597 12.9049 2.5 12.003 2.5C11.101 2.5 10.3333 2.81597 9.7 3.44792C9.06667 4.07986 8.75 4.84722 8.75 5.75V8.15Z",
    fill: "#B0B5AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/passwordIcon.978ecd69f02bafdaf05f09e55e84ff18.svg";
export { ForwardRef as ReactComponent };